import { Helmet } from 'react-helmet-async'

const appleIconSizes = [
  '57x57',
  '60x60',
  '72x72',
  '76x76',
  '114x114',
  '120x120',
  '144x144',
  '152x152',
  '180x180'
]

const appleIconLinks = appleIconSizes.map(size => ({
  rel: 'apple-touch-icon',
  sizes: size,
  href: `/images/apple-icon-${size}.png`
}))

const defaultHelmetLinks: Array<{
  rel: string
  sizes: string
  href: string
  type?: string
}> = [
  // apple touch icons
  ...appleIconLinks,
  // png icons
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '192x192',
    href: '/images/android-icon-192x192.png'
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '32x32',
    href: '/images/favicon-32x32.png'
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '96x96',
    href: '/images/favicon-96x96.png'
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '16x16',
    href: '/images/favicon-16x16.png'
  }
]

const HelmetWrapper = ({
  appInfo,
  name,
  isPending,
  status
}: {
  appInfo: Partial<AppInfoDTOData>
  name: string
  isPending: boolean
  status: 'success' | 'error' | 'pending'
}) => {
  return (
    <Helmet
      defaultTitle={name}
      titleTemplate={`%s | ${isPending ? 'Carregando...' : name || 'VTEX'}`}
    >
      {appInfo?.favicon && (
        <>
          <link
            data-react-helmet="true"
            rel="icon"
            type="image/png"
            href={appInfo?.favicon}
          />
          <meta
            name="msapplication-TileColor"
            content={appInfo?.colors?.primary || '#3c3584'}
          />
          <meta
            name="theme-color"
            content={appInfo?.colors?.primary || '#3c3584'}
          />
        </>
      )}

      {status === 'success' && !appInfo?.favicon && (
        <>
          {defaultHelmetLinks.map(({ rel, sizes, href, type }) => (
            <link
              key={`${rel}-${sizes}-${href}`}
              data-react-helmet="true"
              rel={rel}
              sizes={sizes}
              href={href}
              {...(type ? { type } : {})}
            />
          ))}
          <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
          <meta name="msapplication-TileColor" content="#3c3584" />
          <meta name="theme-color" content="#3c3584" />
        </>
      )}
    </Helmet>
  )
}

export default HelmetWrapper
